import { Metric } from '@models';

export const metrics: { [key: string]: Metric } = {
  time: {
    value: 0,
    unit: 'Second',
    id: '4706d356-81a9-44e6-9c72-5d1676b64fa4',
  } as Metric,
  grasperPath: {
    value: 0,
    unit: 'Integer',
    id: '7bd939c9-a830-4e37-8cc3-62bb521319f8',
  } as Metric,
  scissorsPath: {
    value: 0,
    unit: 'Integer',
    id: '798e44c0-559c-4495-83d6-c6a3673c0dd2',
  } as Metric,
};
